import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  	baseUrl: 'http://devapi.bkz.ro/',
    cartProducts: [],
    wishlistProducts: [],
    currentProduct: {},
    showModal: false,
    showPopupCart: false,
    showPopupWishlist: false
  },

  getters: {
    getNotebooks: state => state.notebooks,
    getSmartphones: state => state.smartphones,
    getAllProducts: state => state.smartphones,
    getProductsInCart: function (state) {
    	if (Cookies.get('Cos') != null)
    	{
    		state.cartProducts = JSON.parse(Cookies.get('Cos'));
      		return state.cartProducts;		
    	}
    	else
    	{
    		return state.cartProducts;
    	}
    },
    getProductsInWishlist: function (state) {
    	if (Cookies.get('Wishlist') != null)
    	{
    		state.wishlistProducts = JSON.parse(Cookies.get('Wishlist'));
      		return state.wishlistProducts;		
    	}
    	else
    	{
    		return state.wishlistProducts;
    	}
    },
    getCurrentProduct: state => state.currentProduct,
    getShowModal: state => state.showModal,
    getPopupCart: state => state.showPopupCart,
    getPopupWishList: state => state.showPopupWishlist
  },

  mutations: {
    ADD_PRODUCT: (state, product_p) => {
      	let productToAdd = {
	      	id : product_p.id,
	      	title : product_p.title,
	      	url : product_p.url,
	      	price : product_p.price.price,
	      	oldPrice : product_p.price.oldPrice,
	      	mainImageUrl : product_p.images != null && product_p.images.bg != null ? product_p.images.bg[0].url : '',
	      	ammount : 1,
	      	products : product_p.products
	      }

      if (product_p.productId != null)
      {
	     productToAdd.id = product_p.productId;
	     productToAdd.price = product_p.price;
	     productToAdd.oldPrice = product_p.oldPrice;
	     productToAdd.mainImageUrl = product_p.mainImageUrl;
      }
      var productEx = state.cartProducts.filter((product) => {
        return product.id == productToAdd.id
      });

      if (productEx.length > 0)
      {
        productEx[0].ammount++;
      }
      else
      {
        state.cartProducts.push(productToAdd);
      }

      Cookies.set('Cos',JSON.stringify(state.cartProducts));
      state.cartProducts = JSON.parse(Cookies.get('Cos'));
    },
    REMOVE_PRODUCT: (state, index) => {
      state.cartProducts.splice(index, 1);
      Cookies.set('Cos',JSON.stringify(state.cartProducts));
    },
    CURRENT_PRODUCT: (state, product) => {
      state.currentProduct = product;
    },
    SHOW_MODAL: (state) => {
      state.showModal = !state.showModal;
    },
    SHOW_POPUP_CART: (state) => {
      state.showPopupCart = !state.showPopupCart;
    },
    SAVE_PRODUCTS: (state) => {
    	Cookies.set('Cos',JSON.stringify(state.cartProducts));
    },
    ADD_PRODUCT_TOWISHLIST: (state, product_p) => {
      	let productToAdd = {
	      	id : product_p.id,
	      	title : product_p.title,
	      	url : product_p.url,
	      	price : product_p.price.price,
	      	oldPrice : product_p.price.oldPrice,
	      	mainImageUrl : product_p.images != null && product_p.images.bg != null ? product_p.images.bg[0].url : '',
	      	ammount : 1,
	      	products : product_p.products
	      }

      if (product_p.productId != null)
      {
	     productToAdd.id = product_p.productId;
	     productToAdd.price = product_p.price;
	     productToAdd.oldPrice = product_p.oldPrice;
	     productToAdd.mainImageUrl = product_p.mainImageUrl;
      }
      var productEx = state.wishlistProducts.filter((product) => {
        return product.id == productToAdd.id
      });

      if (!productEx.length > 0)
      {
        state.wishlistProducts.push(productToAdd);
      }

      Cookies.set('Wishlist',JSON.stringify(state.wishlistProducts));
      state.wishlistProducts = JSON.parse(Cookies.get('Wishlist'));
    },
    REMOVE_PRODUCT_TOWISHLIST: (state, index) => {
      state.wishlistProducts.splice(index, 1);
      Cookies.set('Wishlist',JSON.stringify(state.wishlistProducts));
    },
    SAVE_PRODUCTS_TOWISHLIST: (state) => {
      Cookies.set('Wishlist',JSON.stringify(state.wishlistProducts));
    },
    SHOW_POPUP_WISHLIST: (state) => {
      state.showPopupWishlist = !state.showPopupWishlist;
    },
    IS_IN_WISHLIST: (state, productToAdd) => {
      var i = 0;
      var productEx = state.wishlistProducts.filter((product, index) => {
        if (product.id == productToAdd.id)
        {
        	i = index;
        }
      });
 	  return i;
    }
  },

  actions: {
    addProduct: (context, product) => {
      context.commit('ADD_PRODUCT', product);
    },
    removeProduct: (context, index) => {
      context.commit('REMOVE_PRODUCT', index);
    },
    currentProduct: (context, product) => {
      context.commit('CURRENT_PRODUCT', product);
    },
    showOrHiddenModal: (context) => {
      context.commit('SHOW_MODAL');
    },
    showOrHiddenPopupCart: (context) => {
      context.commit('SHOW_POPUP_CART');
    },
    saveProducts: (context, product) => {
      context.commit('SAVE_PRODUCTS');
    },
    addProductToWishlist: (context, product) => {
      context.commit('ADD_PRODUCT_TOWISHLIST', product);
    },
    removeProductFromWishlist: (context, index) => {
      context.commit('REMOVE_PRODUCT_TOWISHLIST', index);
    },
    saveProductsToWishlist: (context, product) => {
      context.commit('SAVE_PRODUCTS_TOWISHLIST');
    },
	  showOrHiddenPopupWishlist: (context) => {
      context.commit('SHOW_POPUP_WISHLIST');
    },
    isInWishList: (context, product) => {
      context.commit('IS_IN_WISHLIST', product);
    }
  }
});
